import React from 'react';
import PropTypes from 'prop-types';
import { isValidArray } from '../../../utilities/validations';

const BreadcrumbList = ({ links, currentUrl, activePage }) => {
	// Loop through page links to create ListItem objects
	let listItems = [];

	if (isValidArray(links)) {
		for (let x = 0; x < links.length; x++) {
			if (!links?.[x]?.link?.href) continue;

			listItems[x] = `{
				"@type": "ListItem",
				"position": ${x + 2},
				"name": "${links[x].link.title || links[x].link.title}",
				"item": "${process.env.GATSBY_SITE_URL + links[x].link.href}"
			}`;
		}
	}

	return (
		<script
			type='application/ld+json'
			dangerouslySetInnerHTML={{
				__html: `{
				"@context": "https://schema.org",
				"@type": "BreadcrumbList",
				"itemListElement": [
					{
						"@type": "ListItem",
						"position": 1,
						"name": "Pella Windows & Doors",
						"item": "${process.env.GATSBY_SITE_URL}"
					},
					${isValidArray(listItems) ? [...listItems] + ',' : ''}
					{
						"@type": "ListItem",
						"position": ${isValidArray(links) ? links.length + 2 : 2},
						"name": "${activePage}",
						"item": "${process.env.GATSBY_SITE_URL + currentUrl}"
					}
				]
			}`,
			}}
		/>
	);
};

BreadcrumbList.propTypes = {
	links: PropTypes.array,
	activePage: PropTypes.string,
	currentUrl: PropTypes.string,
};

export default BreadcrumbList;
